// extracted by mini-css-extract-plugin
module.exports = {"tagsModalContent":"tags-modal_tagsModalContent__4BH03","tagsModalFooter":"tags-modal_tagsModalFooter__h2Vi6","tagsModalButton":"tags-modal_tagsModalButton__nU__y"};